import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — fusion de classes Tailwind (clsx + tailwind-merge).
 * Convention shadcn/ui : déduplique les classes conflictuelles tout en
 * préservant les conditions clsx.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
